import React, { useEffect, useState } from "react";
import {
  Col,
  FloatingLabel,
  Form,
  FormLabel,
  InputGroup,
  Row,
} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import HelpButton from "../HelpContent/HelpButton";
import MyIcon from "../Common/MyIcon";
import PersonalDetailsIcon from "../../assets/icons/personal_details.svg2";
import {
  useGetPersonalDataQuery,
  useGetUsersSettingsProductsFilterDataQuery,
  useUpdatePersonalDataMutation,
} from "../store/slices/settingsSlice";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { toast } from "react-toastify";
import { parsePhoneNumber } from "react-phone-number-input";
import { pageProps } from "../helpers/pageProps";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";

const { user } = JSON.parse(document.querySelector("#app").dataset.page).props;
const { countries, defaultCountry, defaultTZ } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

function PersonalDetailsModal() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { data: products } = useGetUsersSettingsProductsFilterDataQuery(null, {
    skip: !show,
  });
  const [personalSettings, setPersonalSettings] = useState({
    id: 1,
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    customer_id: 1,
    active: "Y",
    timeout: null,
    locked: "N",
    role_id: 1,
    attempts: 0,
    changed: "2025-03-21",
    temp_pw: "N",
    last_attempt: "2025-04-16 08:41:55",
    last_ip: "172.19.0.1",
    last_client_id: 2,
    temp_code: null,
    temp_valid: null,
    updated_by: 1,
    country_id: 79,
    country: "44",
    updated_when: "2025-04-11T15:49:35.000000Z",
    updated_at: "2025-04-16T07:41:55.000000Z",
    created_at: "2025-03-21T08:53:26.000000Z",
    help_tips: 1,
    contact_id: 0,
    notes: "",
    initials: "",
    tour_guide: "N",
    last_action: null,
    last_comm_used: "1",
    superadmin_permissions: [],
    is_welcome_email_sent: 0,
    products: [],
    user_login_security: null,
    user_roles: [],
    customer_settings_security: {
      id: 1,
      customer_id: 1,
      system_timeout: 2,
      password_change: 30,
      login_attempts: 5,
      secure_data: "N",
      secure_data_override: "N",
      two_factors: "N",
      tf_expire_minutes: 30,
      tf_frequency: "new_user",
      tf_code_attempts: 3,
      allow_impersonation: 1,
    },
    contact: null,
  });
  const [errors, setErrors] = useState({});

  const handlePersonalChange = (e) =>
    setPersonalSettings((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  const { data, isLoading } = useGetPersonalDataQuery(null, { skip: !show });

  useEffect(() => {
    if (data?.User) {
      setPersonalSettings({
        ...data.User,
        mobile: parsePhoneNumber(
          data.User.mobile,
          (countries.find((c) => c.id === data.country_id) || defaultCountry)
            .country_code
        ).nationalNumber,
      });
    }
  }, [data]);

  const [save] = useUpdatePersonalDataMutation();

  return (
    <>
      <FullScreenLoadingIndicator loading={isLoading} />
      <button type="button" className="btn btn-link p-0" onClick={handleShow}>
        <h1 className="fw-bold display-5"> {user.firstName}</h1>
      </button>

      <Modal show={show} onHide={handleClose} size="lg" className="">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Personal Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-purple-gradient-darker-reverse rounded-3 p-4">
          <div className=" ">
            <h5 className=" d-flex align-items-center">
              <MyIcon Icon={PersonalDetailsIcon} className="me-2" />
              <span className="ms-2">
                <span className="fw-bold me-2"> Personal details:</span>
                <HelpButton helpKey="personal-details" />
                <div className="small text-secondary">
                  Manage your personal details here.
                </div>
              </span>
            </h5>
            <hr className="my-3 text-secondary" />
            <Form>
              <Row>
                <Col xs={4}>
                  <FloatingLabel label="Name:">
                    <Form.Control
                      maxLength={15}
                      className="mb-2"
                      placeholder="Name:"
                      name="first_name"
                      onChange={handlePersonalChange}
                      value={personalSettings.first_name}
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={2}>
                  <FloatingLabel label="Initial:">
                    <Form.Control
                      className="mb-2"
                      placeholder="Initial:"
                      name="initials"
                      onChange={handlePersonalChange}
                      value={personalSettings.initials}
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={6}>
                  <FloatingLabel label="Surname">
                    <Form.Control
                      maxLength={20}
                      className="mb-2"
                      placeholder="Surname:"
                      name="last_name"
                      onChange={handlePersonalChange}
                      value={personalSettings.last_name}
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              {errors.first_name && (
                <div className="alert alert-danger p-1 mt-2">
                  {errors.first_name}
                </div>
              )}{" "}
              {errors.last_name && (
                <div className="alert alert-danger p-1 mt-2">
                  {errors.last_name}
                </div>
              )}{" "}
              {errors.initials && (
                <div className="alert alert-danger p-1 mt-2">
                  {errors.initials}
                </div>
              )}
              <Row>
                {/* <FloatingLabel label="Address:">
                <Form.Select
                  defaultValue="Choose..."
                  className="p-3 my-2"
                  name="address"
                  onChange={handlePersonalChange}
                  value={personalSettings.address}
                >
                  <option>Address...</option>
                  <option>...</option>
                </Form.Select>
              </FloatingLabel> */}
                {/* <FloatingLabel label="County:">
                <Form.Control
                  type="county"
                  placeholder="County:"
                  className="p-3 my-2"
                  onChange={handlePersonalChange}
                  name="county"
                  value={personalSettings.county}
                />
              </FloatingLabel> */}
                <Col xs={6}>
                  <div className="my-2">
                    <FloatingLabel label="Email:">
                      <Form.Control
                        type="email"
                        placeholder="Email:"
                        name="email"
                        onChange={handlePersonalChange}
                        className="p-3 mt-1"
                        value={personalSettings.email}
                      />
                    </FloatingLabel>
                  </div>
                  {errors.email && (
                    <div className="alert alert-danger p-1 mt-2">
                      {errors.email}
                    </div>
                  )}
                </Col>
                <Col>
                  <div className="bg-white rounded-2 p-2 my-2">
                    <div>Customer no: {pageProps.customerGatewayId}</div>
                    <div>Account no: {pageProps.accountGatewayId}</div>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="bg-white p-2 rounded-2 my-2">
                    <FormLabel>Phone number:</FormLabel>

                    <InputGroup>
                      <InputGroup.Text>
                        +
                        {
                          (
                            countries.find(
                              (c) => c.id === personalSettings.country_id
                            ) || defaultCountry
                          ).idd
                        }
                      </InputGroup.Text>
                      <Form.Control
                        placeholder="Phone number"
                        aria-label="Phone number"
                        value={personalSettings.mobile}
                        onChange={(e) =>
                          setPersonalSettings((prev) => ({
                            ...prev,
                            mobile: e.target.value,
                          }))
                        }
                      />
                    </InputGroup>
                  </div>
                  {errors.mobile && (
                    <div className="alert alert-danger p-1 mt-2">
                      {errors.mobile}
                    </div>
                  )}
                </Col>
                <Col xs={6}>
                  <div className="bg-white p-2 rounded-3 my-2">
                    <div className="mb-1">Country:</div>
                    <Input
                      inputType="select"
                      onChange={([v]) =>
                        handlePersonalChange({
                          target: { name: "country_id", value: v },
                        })
                      }
                      value={[personalSettings.country_id]}
                      options={countries.map((c) => ({
                        label: c.country_name,
                        value: c.id,
                      }))}
                    />
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="bg-white p-2 rounded-3 my-2">
                    <div className="text-secondary"> User Roles: </div>
                    <div>
                      {personalSettings.user_roles
                        .map((role) => role.name)
                        .join(", ")}
                    </div>
                  </div>
                </Col>
              </Row>
              {/* <Form.Check
                type="checkbox"
                label="Check me out"
                className="p-3 my-2 fs-5 ms-2"
              /> */}
              <div className="d-flex justify-content-end">
                <Button
                  className="btn btn-colored-reverse rounded-pill fw-bold"
                  onClick={async () => {
                    const { data: d, error: e } = await save({
                      body: personalSettings,
                    });
                    if (e) {
                      toast.error(e.data.message);
                      setErrors(e.data.errors);
                      return;
                    }
                    if (d.status === "error") {
                      toast.error(d.message);
                    }
                    if (d.status === "success") {
                      toast.success(d.message);
                    }
                  }}
                >
                  Save Changes
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PersonalDetailsModal;
